// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 18:25:51

export default {
  "id": "police-chase-drifter",
  "slug": "police-chase-drifter",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/854f498c48134cbb9da539efabf1e7f2-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/854f498c48134cbb9da539efabf1e7f2/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Police Chase Drifter",
      "description": "Police Chase Drifter is a fun car game where you get to run from the police, collect money bags and reach to the finishline.\nEarn money to buy more cars, fasters and enjoy the drifting.",
      "instructions": "Arrow keys and WSAD to accelerate, brakes and steer.",
      "genres": [
        "Racing & Driving",
        "Simulation"
      ],
      "tags": [
        "car",
        "drift",
        "police",
        "top"
      ]
    },
    "zh-CN": {
      "title": "警察追捕漂泊者",
      "description": "警察追捕漂移者是一款有趣的赛车游戏，你可以躲避警察，收集钱袋并冲向终点线。\n赚取金钱购买更多汽车，享受更快的速度和漂移乐趣。",
      "instructions": "方向键和WSAD键用于加速、刹车和转向。",
      "genres": [
        "赛车与驾驶",
        "模拟"
      ],
      "tags": [
        "汽车",
        "漂移",
        "警察",
        "顶尖"
      ]
    },
    "zh-TW": {
      "title": "警察追逐漂泊者",
      "description": "警察追逐漂移是一款有趣的車遊戲，您可以逃避警察的追捕，收集錢袋並達到終點線。\n賺取金錢以購買更多車輛、更快的車輛並享受漂移的樂趣。",
      "instructions": "方向鍵及 WSAD 鍵加速、煞車及方向操控。",
      "genres": [
        "賽車與駕駛",
        "模擬"
      ],
      "tags": [
        "車輛",
        "漂移",
        "警察",
        "頂端"
      ]
    },
    "zh-HK": {
      "title": "警察追擊飄逸者",
      "description": "警察追逐飄逸者是一款有趣的車輛遊戲，讓你得以逃避警察追捕，收集錢袋並達到終點線。\n賺取金錢以購買更多車輛、更快的車輛並享受飄逸樂趣。",
      "instructions": "方向鍵及WSAD按鍵加速、煞車及轉向。",
      "genres": [
        "賽車及駕駛",
        "模擬"
      ],
      "tags": [
        "車",
        "漂移",
        "警察",
        "頂尖"
      ]
    },
    "ja": {
      "title": "警察追跡・ドライフライター",
      "description": "警察追跡・ドライバーは、警察から逃げ、金袋を集め、ゴールまで到達する楽しいカーゲームです。\nお金を稼いで、もっと速い車を購入し、ドリフトの楽しさを味わってください。",
      "instructions": "アーロークエーカーとWSADで加速、ブレーキとステアリング。",
      "genres": [
        "レーシング＆ドライビング",
        "シミュレーション"
      ],
      "tags": [
        "車",
        "ドリフト",
        "警察",
        "トップ"
      ]
    },
    "ko": {
      "title": "경찰 추격 드라이버",
      "description": "경찰 추격 드라이버는 경찰로부터 도망치며 돈을 모으고 목적지에 도달하는 재미있는 자동차 게임입니다. 돈을 벌어 더 많은 차를 구매하고 빠른 차를 즐기세요.",
      "instructions": "아로어 키와 WSAD를 가속, 브레이크 및 방향지정에 사용하세요.",
      "genres": [
        "레이싱 & 드라이빙",
        "시뮬레이션"
      ],
      "tags": [
        "カー",
        "드래프트",
        "경찰",
        "탑"
      ]
    },
    "fr": {
      "title": "Chasse à la police Drifter",
      "description": "Chasse à la police Drifter est un jeu de voiture amusant où vous pouvez fuir la police, ramasser des sacs d'argent et atteindre la ligne d'arrivée.\nGagnez de l'argent pour acheter plus de voitures, plus rapides et profitez du drift.",
      "instructions": "Touches flèches et WSAD pour accélérer, freiner et diriger.",
      "genres": [
        "Courses et conduite",
        "Simulation"
      ],
      "tags": [
        "voiture de drift",
        "police",
        "championnat de vitesse"
      ]
    }
  }
};
